package us.laantech.admin.menu.clients.ads.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

// A bordered, titled region. All four panels (files, processing, sequence, preview) share this so
// they read as distinct boxes. Follows the repo's only border precedent: Card(border = 1.dp Gray).
@Composable
fun SectionPanel(
    title: String,
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit,
) {
    Card(modifier = modifier.padding(4.dp), border = BorderStroke(1.dp, Color.Gray)) {
        Column(Modifier.fillMaxSize().padding(8.dp)) {
            Text(title)
            Spacer(Modifier.height(8.dp))
            content()
        }
    }
}